import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
export default function ProductMediaFields({ image, currentImage = '', upcs, onImage, onUpcs, disabled }) {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const preview = image === undefined ? currentImage : image;
    function add() {
        const value = code.trim();
        if (!/^(?:[0-9]{8}|[0-9]{12}|[0-9]{13})$/.test(value)) { setError('El código debe tener 8, 12 o 13 dígitos.'); return; }
        if (upcs.includes(value)) { setError('Este código ya está en la lista.'); return; }
        onUpcs([...upcs, value]); setCode(''); setError('');
    }
    async function select(event) {
        const file = event.target.files?.[0]; event.target.value = '';
        if (!file) return;
        if (!['image/png','image/jpeg'].includes(file.type) || file.size > 5 * 1024 * 1024) { setError('Selecciona PNG o JPEG de hasta 5 MB.'); return; }
        setError('');
        const reader = new FileReader();
        reader.onload = () => onImage(reader.result);
        reader.onerror = () => setError('No se pudo leer el archivo.');
        reader.readAsDataURL(file);
    }
    return <fieldset className="product-media-fields" disabled={disabled}>
        <legend>Imagen y códigos de barras (opcionales)</legend>
        {error && <p role="alert">{error}</p>}
        {preview && <img className="product-image-preview" src={preview} alt="Vista previa del producto" />}
        <label>Subir imagen<input aria-label="Subir imagen" type="file" accept="image/png,image/jpeg" onChange={select} /></label>
        <small>PNG o JPEG, hasta 5 MB y 16 megapíxeles. Se guardará una copia en Syncro.</small>
        {preview && <Button type="button" label="Quitar imagen" className="p-button-text" onClick={() => onImage(null)} />}
        <label>Código de barras<InputText aria-label="Código de barras" inputMode="numeric" value={code} onChange={e => setCode(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); add(); } }} placeholder="Escanea o escribe el código" /></label>
        <Button type="button" label="Agregar código de barras" onClick={add} />
        <small>Agrega cada código a la lista antes de guardar. Conservamos los ceros iniciales.</small>
        <ul>{upcs.map(upc => <li key={upc}><span>{upc}</span> <Button type="button" label="Quitar" aria-label={`Quitar código ${upc}`} className="p-button-text" onClick={() => onUpcs(upcs.filter(value => value !== upc))} /></li>)}</ul>
    </fieldset>;
}
// Each operation is saved independently. Callers keep the confirmed product on failures,
// so retries never create another product or repeat an already completed removal.
export async function saveProductMedia(product, { image, upcs, removedUpcs = (product.upcs || []).filter(code => !upcs.includes(code)) }, api, onProgress) {
    let current = product;
    const persist = updated => { current = updated; onProgress(updated); };
    for (const upc of upcs.filter(code => !(current.upcs || []).includes(code))) {
        persist(await api(`${current._id}/upcs`, { method: 'POST', data: { upc } }));
    }
    for (const upc of removedUpcs) {
        persist(await api(`${current._id}/upcs/${upc}`, { method: 'DELETE' }));
    }
    if (image !== undefined) {
        persist(await api(`${current._id}/image`, { method: 'PUT', data: { image: image === null ? null : image.split(',')[1], version: current.__v || 0 } }));
    }
    return current;
}
